import React, { useEffect, useState } from 'react';
import { 
    Container, Typography, Table, TableBody, TableCell, 
    TableContainer, TableHead, TableRow, Paper, Avatar, 
    Chip, Box, IconButton, AvatarGroup, Tooltip
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { userService } from '../services/user';

const Users = () => {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        try {
            const result = await userService.getAll();
            setUsers(result.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this user record?')) {
            try {
                await userService.delete(id);
                loadUsers();
            } catch (error) {
                console.error(error);
            }
        }
    };

    return (
        <Container maxWidth="lg" sx={{ mt: 4 }}>
            <Box mb={3}>
                <Typography variant="h4">User Management</Typography>
                <Typography color="textSecondary">
                    Unified view of all users across registered applications.
                </Typography>
            </Box>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>User (Primary Email)</TableCell>
                            <TableCell>Identities</TableCell>
                            <TableCell>Applications</TableCell>
                            <TableCell align="right">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.map((user) => (
                            <TableRow key={user._id}>
                                <TableCell>
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <AvatarGroup max={3}>
                                            {user.identities?.map((id, idx) => (
                                                <Tooltip key={idx} title={`${id.provider}: ${id.name}`}>
                                                    <Avatar src={id.profilePic} alt={id.name} />
                                                </Tooltip>
                                            ))}
                                        </AvatarGroup>
                                        <Box>
                                            <Typography variant="subtitle2">
                                                {user.identities?.[0]?.name || 'Unknown'}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                {user._id}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box display="flex" gap={0.5} flexWrap="wrap">
                                        {user.identities?.map((id, idx) => (
                                            <Chip 
                                                key={idx}
                                                label={id.provider} 
                                                size="small" 
                                                sx={{ textTransform: 'capitalize' }}
                                                color="primary"
                                                variant="outlined"
                                            />
                                        ))}
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box display="flex" gap={0.5} flexWrap="wrap">
                                        {user.applications?.length > 0 ? (
                                            user.applications.map((app) => (
                                                <Chip 
                                                    key={app._id || app} 
                                                    label={app.name || `ID: ${app.substring?.(0,6)}...`} 
                                                    size="small" 
                                                    color="secondary"
                                                    variant="outlined"
                                                />
                                            ))
                                        ) : (
                                            <Typography variant="caption" color="textSecondary">No apps linked</Typography>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell align="right">
                                    <IconButton onClick={() => handleDelete(user._id)} color="error">
                                        <Delete />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
};

export default Users;
